import React from "react";

import Layout from '@components/layout';
import DepositPoliciesTemplate from "@components/depositPoliciesPage/depositPoliciesTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <DepositPoliciesTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
